// extracted by mini-css-extract-plugin
export default {"control":"tog_con_25h8V","knob":"tog_kno_1CBeM","loadingIcon":"tog_loa_3qGvh","checked":"tog_che_28-7P"};